import { RouteRecordRaw } from "vue-router";
import { AuthGuardService } from "@/_guard/AuthGuardService";


import legalLayout from "@/modules/legal/views/viewLegalIndex.vue";
import privacyPolicy from "@/modules/legal/views/viewLegalPrivacyPolicy.vue";
import cookiePolicy from "@/modules/legal/views/viewLegalCookiePolicy.vue";
import eula from "@/modules/legal/views/viewLegalEula.vue";
import publisher from "@/modules/legal/views/viewLegalPublisherAgreement.vue";

const auth = new AuthGuardService();

export const LegalRoutes: RouteRecordRaw[] = [
  {
    path: '/legal',
    name: 'viewLegalIndex',
    meta: {title: 'Legal'},
    component: legalLayout,
    beforeEnter: auth.guard,
    children: [
      {
        path: '/privacy-policy',
        name: 'viewLegalPrivacyPolicy',
        meta: { title: 'Privacy Policy' },
        component:privacyPolicy
      },
      {
        path: '/cookie-policy',
        name: 'viewLegalCookiePolicy',
        meta: { title: 'Cookie Policy' },
        component:cookiePolicy
      },
      {
        path: '/eula',
        name: 'viewLegalEula',
        meta: { title: 'End User License Agreement (EULA)' },
        component:eula
      },
      {
        path: '/publisher-agreement',
        name: 'viewLegalPublisherAgreement',
        meta: { title: 'Publisher Agreement' },
        component:publisher
      },
    ]
  },
];